module.exports = __webpack_public_path__ + "startpage-logged-out-b8bc31fe/Background_02_7x2_a-8f327964b33bbd7c5e28927cfcac851d.svg";